import {
    ADAPTIVE_BREAKPOINT,
} from '../constants';

import {
    useWindowWidth,
} from './useWindowWidth';

export function useIsMobile() {
    const {windowWidth} = useWindowWidth();

    return windowWidth < ADAPTIVE_BREAKPOINT.W1024;
}
